import React from "react";

import Box from "./Box";
import CrossBoxIcon from "@assets/images/crossbox_icon.svg";

interface IErrorBox {
  message: string | JSX.Element;
}

export default function ErrorBox({ message }: IErrorBox) {
  return <Box message={message} icon={CrossBoxIcon} bgColor={"#FF00001A"} />;
}
